import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

import AdjustTroveComponents from "./AdjustTroveComponents";

import { Form } from "react-final-form";

type AdjustTroveProps = {
  disconnected?: boolean;
  borrowMode: "normal" | "lever" | "unlever";
  setBorrowMode: any;
} & BoxProps;

const AdjustTrove: React.FC<AdjustTroveProps> = ({
  disconnected,
  borrowMode,
  setBorrowMode,
  ...props
}) => {
  const getFormattedValue = (value: string) => {
    if (/^[0-9.]*$/.test(value)) {
      return value;
    }
    return "";
  };
  return (
    <Box w="full">
      <Form
        onSubmit={() => undefined}
        format={getFormattedValue}
        render={({ values, form }) => (
          <>
            <AdjustTroveComponents
              disconnected={disconnected === undefined ? false : disconnected}
              borrowMode={borrowMode}
              setBorrowMode={setBorrowMode}
              values={values}
              form={form}
            />
          </>
        )}
      />
    </Box>
  );
};

export default AdjustTrove;
